import React, { useEffect } from 'react'
import { OrderManagementSection } from '@modules/common/models/enums/OrderManagement'
import { BlankPage } from '@modules/wholesale/blankPage/component/BlankPage'
import { stores } from '@stores'
import isEmpty from 'lodash/isEmpty'
import { useObserver } from 'mobx-react-lite'
import { OrderManagementWrapper } from './OrderManagementWrapper'
import { EnhancedOrderDetails } from './EnhancedOrderDetails'

const EnhancedOrderManagementSummary = () => {
  return useObserver(function useHook() {
    const {
      nav: {
        queryParams: { section, orderId }
      },
      search: { searchKey, clearSearchKey },
      filterModalStore: { wsAppliedFilters, onFilterClear },
      productConfiguration: { loadedConfigData }
    } = stores

    useEffect(() => {
      if (searchKey?.length) {
        clearSearchKey()
      }
      if (!isEmpty(wsAppliedFilters)) {
        onFilterClear(null)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orderId])

    if (!loadedConfigData) {
      return null
    }

    switch (section) {
      case OrderManagementSection.clientOrder:
      case OrderManagementSection.retailOrder:
        if (orderId) {
          return <EnhancedOrderDetails />
        } else {
          return <OrderManagementWrapper />
        }
      default:
        return <BlankPage />
    }
  })
}

export default EnhancedOrderManagementSummary
